import { createSlice } from "@reduxjs/toolkit";

const deviceActionSlice = createSlice({
  name: "deviceAction",
  initialState: {
    deviceList: [],
    selectedDevice: {},
    deviceStats: {
      cleaningSession: 0,
      waterSaved: 0,
      effortSaved: 0
    }
  },
  reducers: {
    updateDeviceList(state, action) {
      state.deviceList = action.payload;
    },
    updateDeviceStats(state, action) {
      state.deviceStats = action.payload.deviceStats;
    },
    updateSelectedDevice(state, action) {
      state.selectedDevice = action.payload.selectedDevice;
    },
    updateDeviceStatus(state, action) {
      let deviceList = state.deviceList;
      let deviceIndex = deviceList.findIndex(
        (device) => device.deviceId === action.payload.deviceId
      );
      deviceList[deviceIndex].isConnected = action.payload.isConnected;
      state.deviceList = deviceList;
    },
    updateDeviceRunningStatus(state, action) {
      console.log("updating running status ")
      let { deviceList } = state;
      let deviceIndex = deviceList.findIndex(
        (device) => device.deviceId === action.payload.deviceId
      );
      deviceList[deviceIndex].isDeviceStatusLoading = false;
      deviceList[deviceIndex].isRunning = action.payload.isRunning;
      deviceList[deviceIndex].isDeviceStatusLoading = false;
      deviceList[deviceIndex].isDeviceScheduleLoading = false;
      state.deviceList = deviceList;
    },
    updateDeviceLoadingStatus(state, action) {
      
      let { deviceList } = state;
      let deviceIndex = deviceList.findIndex(
        (device) => device.deviceId === action.payload.deviceId
      );
      deviceList[deviceIndex].isDeviceStatusLoading = action.payload.isDeviceStatusLoading;
      deviceList[deviceIndex].isDeviceScheduleLoading = action.payload.isDeviceScheduleLoading;
      
      state.deviceList = deviceList;
    },
    updateSelectedDeviceLoadingStatus(state, action) {
      let { selectedDevice } = state;
      selectedDevice.isDeviceScheduleLoading = action.payload.isDeviceScheduleLoading;
      selectedDevice.scheduleSuccess = action.payload.scheduleSuccess;
      state.selectedDevice = selectedDevice;
    }
  },
});

export const deviceActionActions = deviceActionSlice.actions;

export default deviceActionSlice;
